import { useEffect, type ReactNode } from 'react';
import { useAdminAuthStore } from '../auth/store';
import { LoginPage } from '../pages/LoginPage';

interface AdminAuthGuardProps {
  readonly children: ReactNode;
}

export function AdminAuthGuard({ children }: AdminAuthGuardProps) {
  const isAuthenticated = useAdminAuthStore((state) => state.isAuthenticated);
  const user = useAdminAuthStore((state) => state.user);
  const fetchUser = useAdminAuthStore((state) => state.fetchUser);

  useEffect(() => {
    if (isAuthenticated && !user) {
      void fetchUser();
    }
  }, [isAuthenticated, user, fetchUser]);

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <>{children}</>;
}
